<template>
    <path
        d="M19.7857 7.64453H1.21429C0.819815 7.64453 0.5 7.96435 0.5 8.35882C0.5 8.7533 0.819815 9.07311 1.21429 9.07311H19.7857C20.1802 9.07311 20.5 8.7533 20.5 8.35882C20.5 7.96435 20.1802 7.64453 19.7857 7.64453Z"
    />
    <path
        d="M1.21429 1.92858H19.7857C20.1802 1.92858 20.5 1.60876 20.5 1.21429C20.5 0.819815 20.1802 0.5 19.7857 0.5H1.21429C0.819815 0.500039 0.5 0.819815 0.5 1.21429C0.5 1.60876 0.819815 1.92858 1.21429 1.92858Z"
    />
    <path
        d="M19.7857 14.7852H1.21429C0.819815 14.7852 0.5 15.1049 0.5 15.4994C0.5 15.894 0.819815 16.2137 1.21429 16.2137H19.7857C20.1802 16.2137 20.5 15.8939 20.5 15.4994C20.5 15.105 20.1802 14.7852 19.7857 14.7852Z"
    />
</template>
